import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { Setting, SettingCategory } from '../models/settings';

interface GetSettingCategoriesResponse {
	setting_categories: SettingCategory[];
}

interface GetSettingsByCategoryResponse {
	settings: Setting[];
}

export const onGetSettingCategories = () => {
	return axios.get<JsonResponse<GetSettingCategoriesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/setting-categories`);
};

export const onGetSettingsByCategory = (id: number) => {
	return axios.get<JsonResponse<GetSettingsByCategoryResponse>>(`${environment.BASE_API_ENDPOINT}/admin/settings/get-by-category/${id}`);
};

export const onUpdateSetting = (settingId: number, data: any) => {
	return axios.put<JsonResponse<Setting>>(`${environment.BASE_API_ENDPOINT}/admin/settings/${settingId}`, data);
};

export const onUpdateImageSetting = (settingId: number, imageData: FormData) => {
	return axios.post<JsonResponse<Setting>>(`${environment.BASE_API_ENDPOINT}/admin/settings/${settingId}`, imageData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};
